/* eslint-disable max-len */
import React from 'react';

interface IEditProps {
    width?: number | string;
    height?: number | string;
}

const Edit: React.FC<IEditProps> = ({width = 12, height = 12}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.9999 10.75C11.414 10.7501 11.7499 11.0858 11.7499 11.5C11.7498 11.9141 11.414 12.2499 10.9999 12.25H6.49986C6.08566 12.25 5.74989 11.9142 5.74986 11.5C5.74986 11.0858 6.08565 10.75 6.49986 10.75H10.9999Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.63072 2.89844L9.08677 4.35352L9.61607 5.41309L9.08677 5.94531L4.41783 10.6143C4.17409 10.858 3.87133 11.0363 3.54088 11.1348L0.721541 11.9639C0.524667 12.0201 0.313533 11.9666 0.165877 11.8213C0.018221 11.676 -0.0352942 11.4625 0.0232987 11.2656L0.8524 8.44336C0.950818 8.11308 1.12933 7.81104 1.37291 7.56738L6.57115 2.36914L7.63072 2.89844ZM2.09263 8.45117C2.02009 8.54251 1.9633 8.64797 1.93053 8.7627L1.39146 10.5928L3.22447 10.0537C3.33678 10.0186 3.44236 9.96505 3.53599 9.89258L3.74888 9.3623H2.99986C2.79361 9.3623 2.62486 9.19355 2.62486 8.9873V8.2373L2.09263 8.45117Z"
                fill="currentColor"
            />
            <path
                d="M8.50279 0.4375C9.08873 -0.148438 10.0379 -0.148438 10.6239 0.4375L11.5448 1.36133C12.1306 1.94727 12.1307 2.89652 11.5448 3.48242L10.411 4.61621L7.36607 1.57227L7.63365 1.30664L8.16295 0.777344L8.50084 0.4375H8.50279Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Edit;